module.exports = () => typeof window === 'undefined';